import { BaseballIncidentId } from '@collector/sportsapi-client-legacy'

import { CustomIncidentNames } from '../../configuration'

export const customIncidentNames: CustomIncidentNames<BaseballIncidentId> =
  new Map([[BaseballIncidentId.InPlayRun, 'In play run(s)']])
